import angular from 'angular';
import tzlookup from 'tz-lookup';
import { debounce, cloneDeep, includes, pull, get, isUndefined, set, isNumber, pick } from 'lodash';
import { localStorage, options, unitOfTime } from '../../utils';
import '../../services/globals';
import '../../services/timezone';
import '../../services/user';
import '../../services/auth';
import '../../services/language';
import '../../services/location';
import '../../services/line-flow-type-organization';
import '../../services/place';
import '../../services/errors';
import '../../services/category';
import '../../services/country';
import '../../services/place-messages';
import '../../services/organization';

const module = angular.module('whyline.modals.place', [
  'ngMap',
  'whyline.services.globals',
  'whyline.services.timezone',
  'whyline.services.user',
  'whyline.services.auth',
  'whyline.services.language',
  'whyline.services.location',
  'whyline.services.line-flow-type-organization',
  'whyline.services.place',
  'whyline.services.errors',
  'whyline.services.category',
  'whyline.services.country',
  'whyline.directives.focusme',
  'whyline.services.place-messages',
  'whyline.services.organization',
]);

const PlaceModalController = (
  // Imports
  $scope,
  $uibModalInstance,
  $translate,
  $timeout,
  Slug,
  dialog,
  // Resolve
  placeId,
  organization,
  // Services
  UserService,
  LocationService,
  LanguageService,
  TimezoneService,
  PlaceService,
  AuthService,
  NotificationService,
  ErrorService,
  CategoryService,
  CountryService,
  LineFlowTypeOrganizationService,
  PlaceMessagesService,
  OrganizationService,
  API_URL,
  Upload,
  $http,
) => {
  'ngInject';

  const namePattern = /^[\u0621-\u064Aa-zA-Zàáâäãåąč&ćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽð:/ ,.'-+\d.*-]+$/;
  $scope.currentOrg = OrganizationService.GetCurrent();
  $scope.loaded = false;
  $scope.validEmail = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,5})$/;
  $scope.urlPattern = /^(HTTP:\/\/WWW\.|HTTPS:\/\/WWW\.|HTTP:\/\/|HTTPS:\/\/|http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  $scope.minValidName = /^[ a-zA-Z0-9_.+-]*(?:[a-zA-Z][ a-zA-Z0-9_.+-]*){2,}$/;
  $scope.blockSaveButton = false;
  $scope.editCallLogicsScope = {
    options: options.filter((o) => o.onlyPlace || o.placeLines),
    selectedOption: options.filter((o) => o.onlyPlace || o.placeLines)[0].key,
  };
  $scope.searchFields = [];
  $scope.endUserPersonalData = [];
  $scope.idFieldRequired = false;
  $scope.nameAndLastNameFieldsRequired = false;
  $scope.selectedDefaultIdentification = {
    value: undefined,
  };

  const user = localStorage.get('user');
  $scope.superAdmin = user && user.sudo;

  $scope.orgAdmin =
    user &&
    user.permissions.filter(
      (p) => p.role.name === 'Organization Admin' && p.role.organizationId === organization._id,
    );

  $scope.enterpriseType = organization.configuration.queuer.enterpriseType;
  $scope.showButtonShowPeopleAheadAfterCheckIn =
    organization.configuration.mobileApp.showPeopleAheadAfterCheckIn;
  $scope.placeMessages = [];

  $scope.showButtonSupportsLinkedProfessionals =
    organization.configuration.agenda.supportsLinkedProfessionals;

  $scope.delayDeliveryUnitOfTime = {
    options: unitOfTime,
  };
  $scope.surveyMonkey = {};
  const addEmptyIdentification = (identifications) => {
    if (identifications.find((id) => id.empty)) {
      return;
    }

    const valEmpty = () => false;
    const empty = {
      empty: true,
      inputType: 'text',
      key: '',
      name: $translate.instant('select_option'),
      show: true,
      validator: valEmpty.toString(),
    };

    identifications.unshift(empty);
  };

  $scope.onPlanChanged = () => {
    $scope.place.plan.name = '';
  };

  $scope.setDefaultIndentificationsList = () => {
    const currentIdentifications = $scope.place.requirements.identifications;
    $scope.availableDefaultIdentifications = currentIdentifications.filter((id) => id.show);
    $scope.selectedDefaultIdentification.value =
      currentIdentifications.find((id) => id.default) ||
      currentIdentifications.find((id) => id.empty);
  };

  $scope.updateDefaultIdentification = () => {
    const defaultKey = get($scope.selectedDefaultIdentification, 'value.key', undefined);

    const { identifications } = $scope.place.requirements;

    identifications.forEach((id) => {
      id.default = false;
      return id;
    });

    if (!defaultKey) {
      return;
    }

    const defaultId = identifications.find((id) => id.key === defaultKey);

    if (defaultId) {
      defaultId.default = true;
    }
  };

  // Init
  $scope.forms = {};
  $scope.uploadmetadata = null;
  $scope.status = {
    user: {
      isOpen: !placeId,
      isDisabled: !!placeId,
    },
    location: {
      isOpen: !!placeId,
      isDisabled: !placeId,
    },
    information: {
      isOpen: false,
      isDisabled: true,
      shouldNameBeFocused: false,
    },
    configuration: {
      isOpen: false,
      isDisabled: !placeId,
    },
    messages: {
      isOpen: false,
      isDisabled: true,
    },
    metadata: {
      isOpen: false,
      isDisabled: false,
    },
    capacityControl: {
      isOpen: false,
      isDisabled: false,
    },
    surveyMonkeyisOpen: {
      isOpen: false,
      isDisabled: false,
    },
    noPlace: false,
    showTooltip: false,
  };

  const uploadMetdataFile = (aPlaceId) => {
    if (!aPlaceId) {
      NotificationService.Warning($translate.instant('save_before_continue'));
      return Promise.resolve();
    }

    const {
      place: {
        metadata: { delimiter },
      },
      uploadmetadata,
    } = $scope;

    if (uploadmetadata) {
      const configuration = {
        url: `${API_URL}metadata/${aPlaceId}?delimiter=${delimiter}`,
        method: 'POST',
        file: uploadmetadata,
      };

      return Upload.upload(configuration)
        .then(() => {
          NotificationService.Success($translate.instant('metadata_uploaded_ok'));
        })
        .catch((err) => {
          console.log('uploadMetadataFile =>', err);

          NotificationService.Error($translate.instant('metadata_uploaded_error'));
        });
    }
    return Promise.resolve();
  };

  $scope.deleteMetadata = () => {
    const n = name || '';
    dialog.confirm($translate.instant('metadata_remove_sure').replace('{name}', n)).then(() => {
      const {
        place: { _id },
      } = $scope;

      const url = `${API_URL}metadata/${_id}`;

      $http
        .delete(url)
        .then(() => {
          NotificationService.Success($translate.instant('metadata_deleted_ok'));
        })
        .catch((err) => {
          console.log('deleteMetadata =>', err);

          NotificationService.Error($translate.instant('metadata_deleted_error'));
        });
    });
  };

  $scope.removeMetadataFile = () => {
    $scope.uploadmetadata = null;
  };

  $scope.uploadMetadataFile = async (file) => {
    $scope.uploadmetadata = file;
  };

  $scope.languages = {
    list: {
      en: 'English',
      es: 'Español',
      pt: 'Portugués',
      fr: 'Frances',
    },
  };

  const SUPPORTED_LANGUAGES = ['en', 'es', 'pt', 'fr'];
  const DEFAULT_LANGUAGE = 'en';
  const language = includes(SUPPORTED_LANGUAGES, $translate.use())
    ? $translate.use()
    : DEFAULT_LANGUAGE;

  const field = `name_${language}`;

  $scope.categoriesSettings = {
    template: `<b>{{option.${field}}}</b>`,
    externalIdProp: 'category',
    displayProp: field,
    idProp: '_id',
    searchField: field,
    enableSearch: true,
    keyboardControls: true,
    selectedToTop: true,
    selectionLimit: 3,
    scrollable: true,
  };

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('multiselect_todos'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('multiselect_seleccionar'),
    searchPlaceholder: $translate.instant('multiselect_buscar'),
    selectionCount: $translate.instant('multiselect_seleccionados'),
  };
  $scope.userExists = true;
  $scope.canComplete = false;

  const enabledForMobileApp = organization.enabledForMobileApp || true;
  const hiddenInMobileApp = organization.hiddenInMobileApp || false;

  const emptyPlace = {
    name: '',
    language: LanguageService.GetBrowserLanguage(),
    categories: organization.categories,
    timezone: '',
    branchId: '',
    enabledForMobileApp,
    hiddenInMobileApp,
    configuration: {
      noAppointmentsAvailableMessage: organization.configuration.noAppointmentsAvailableMessage,
      aliasType: organization.configuration.queuer.aliasType,
      aliasGetter: organization.configuration.queuer.aliasGetter,
      appointmentReminder: {
        enabled: get(organization, 'configuration.appointmentReminder.enabled', false),
      },
      boxLabelRequired: organization.configuration.queuer.boxLabelRequired,
      canConfirmAppointments: organization.configuration.queuer.canConfirmAppointments,
      canConfirmSpontaneous: false,
      canEditAppointments: organization.configuration.queuer.canEditAppointments,
      canGiveAppointments: organization.configuration.queuer.canGiveAppointments,
      validateClosingHours: false,
      viewEasyTotem: false,
      viewNewTotem: true,
      searchAppointmentsBy: 'email',
      showCommercialOffer: organization.configuration.showCommercialOffer,
      user: organization.configuration.user,
      showPriorityTotem: false,
      canViewTotemToggles: false,
      checkIn: {
        min: organization.configuration.checkIn.min,
        max: organization.configuration.checkIn.max,
      },
      requireAppointmentConfirmation:
        organization.configuration.queuer.requireAppointmentConfirmation,
      canProcessAppointment: organization.configuration.queuer.canProcessAppointment,
      canSendAppointmentDelayAlert:
        organization.configuration.mobileApp.canSendAppointmentDelayAlert || false,
      checkInTolerance: organization.configuration.queuer.checkInTolerance || 2,
      closedMessage: organization.configuration.queuer.closedMessage,
      reasonRequired: organization.configuration.reasonRequired,
      reasons: organization.configuration.reasons,
      canSkipProcessOrder: organization.configuration.queuer.canSkipProcessOrder,
      requeue: organization.configuration.queuer.requeue,
      requestReasonAndMotive: organization.configuration.requestReasonAndMotive,
      retained: organization.configuration.queuer.retained,
      showWaitingInLineInPlace: organization.configuration.queuer.showWaitingInLineInPlace,
      showWorkingDay: organization.configuration.queuer.showWorkingDay,
      multiLanguageKiosk: false,
      sla: 0,
      allowMultipleSubscriptions: false,
      nowServingEmail: false,
      checkInEmail: false,
      overbooking: {
        enabled: get(organization, 'configuration.overbooking.enabled', false),
        quantity: get(organization, 'configuration.overbooking.quantity', 1),
      },
      overlapAppointment: {
        enabled: get(organization, 'configuration.overlapAppointment.enabled', false),
      },
      endUserPersonalData: [
        {
          name: 'identification',
          qmsRequired: false,
          qmsShow: true,
          webAgendaRequired: false,
          webAgendaShow: false,
        },
        {
          name: 'phoneNumber',
          qmsRequired: false,
          qmsShow: true,
          webAgendaRequired: false,
          webAgendaShow: true,
        },
        {
          name: 'email',
          qmsRequired: false,
          qmsShow: true,
          webAgendaRequired: true,
          webAgendaShow: true,
        },
        {
          name: 'name',
          qmsRequired: true,
          qmsShow: true,
          webAgendaRequired: true,
          webAgendaShow: true,
        },
        {
          name: 'lastName',
          qmsRequired: true,
          qmsShow: true,
          webAgendaRequired: true,
          webAgendaShow: true,
        },
      ],
    },
    requirements: organization.configuration.requirements,
    location: {},
    info: {
      website: '',
      phones: [],
      address: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
      street: '',
      streetNumber: '',
    },
    openingDetails: {},
    geoLocation: [],
    checkInCode: '',
    mobileAppConfig: {
      showPeopleAheadAfterCheckIn: true,
      showCheckInButton: true,
      showWaitingTime: true,
      showQRCode: false,
    },
    userAdmin: {
      local: {
        email: '',
        password: '',
      },
      profile: {
        firstName: '',
        lastName: '',
      },
    },
    metadata: {
      enabled: false,
      delimiter: ';',
      fields: {
        mapsText: '',
        maps: [],
        identifier: '',
        email: '',
        phone: '',
      },
    },
    capacityControl: {
      enabled: false,
      configuration: {
        requiresConfirmation: false,
        supportDelay: false,
        enterWithoutConfirmation: false,
        supportTwoWaysSMS: false,
      },
    },
  };
  $scope.lineFlowTypeOrganizationList = [];
  $scope.lineFlowTypeOrganizationSelected = {};

  $scope.setLFTOId = (lftoSelected) => {
    $scope.place.defaultLineFlowTypeOrganization = lftoSelected._id;
  };

  $scope.defaultAppointmentConfirmation = () => {
    if (
      !$scope.place.configuration.canConfirmAppointments ||
      !$scope.place.configuration.canGiveAppointments
    ) {
      $scope.place.configuration.requireAppointmentConfirmation = false;
    }
    if (!$scope.place.configuration.canGiveAppointments) {
      $scope.place.configuration.showWorkingDay = false;
    }
    if (!$scope.place.configuration.canGiveAppointments) {
      $scope.place.configuration.canProcessAppointment = false;
    }
    if ($scope.place.configuration.canGiveAppointments) {
      $scope.place.configuration.canConfirmAppointments = true;
    }
  };

  $scope.negateToggles = () => {
    if (!$scope.place.configuration.viewNewTotem) {
      $scope.place.configuration.multiLanguageKiosk = false;
      $scope.place.configuration.showPriorityTotem = false;
    }
  };

  $scope.modifyShowOrRequiredValue = (fieldName, value, action, applyTo) => {
    const personalData = $scope.endUserPersonalData.find((pd) => pd.name === fieldName);

    if (action.includes('required')) {
      if (value) {
        const completedName = `${applyTo}Show`;
        personalData[completedName] = true;
        if (!$scope.place.configuration.searchAppointmentsBy) {
          $scope.place.configuration.searchAppointmentsBy = personalData.name === 'lastName' ? 'name' : personalData.name;
          NotificationService.Warning($translate.instant('searchField_changed'));
        }
      }
      else {
        if ($scope.place.configuration.searchAppointmentsBy === fieldName) {
          const searchAppointmentsBy = $scope.endUserPersonalData.find(pd =>
            pd.webAgendaRequired && pd.name != fieldName);
          $scope.place.configuration.searchAppointmentsBy = searchAppointmentsBy?.name === 'lastName' ? 'name' : searchAppointmentsBy?.name;
          NotificationService.Warning($translate.instant('searchField_changed'));
        }
      }
    }

    if (action.includes('show') && !value) {
      const completedName = `${applyTo}Required`;

      personalData[completedName] = false;
    }
  };

  $scope.checkAliasType = (fieldName) => {
    if (fieldName === 'identification' || fieldName === 'name' || fieldName === 'lastName') {
      if (fieldName === 'identification') {
        const idField = $scope.endUserPersonalData.find((data) => data.name === fieldName);
        $scope.idFieldRequired = idField.qmsRequired && idField.webAgendaRequired;
      }

      if (fieldName === 'name' || fieldName === 'lastName') {
        const lookSettingsFor = fieldName === 'name' ? 'lastName' : 'name';
        const fieldChanged = $scope.endUserPersonalData.find((data) => data.name === fieldName);
        const anotherNameField = $scope.endUserPersonalData.find(
          (data) => data.name === lookSettingsFor,
        );

        $scope.nameAndLastNameFieldsRequired =
          fieldChanged.qmsRequired &&
          fieldChanged.webAgendaRequired &&
          anotherNameField.qmsRequired &&
          anotherNameField.webAgendaRequired;
      }

      const aliasType = get($scope, 'place.configuration.aliasType');
      if (
        (aliasType === 'lastIdAlias' || aliasType === 'fullNameAlias') &&
        !$scope.idFieldRequired &&
        !$scope.nameAndLastNameFieldsRequired
      ) {
        $scope.place.configuration.aliasType = 'prefixWithIncrementalNumberAlias';
      } else if (
        aliasType === 'lastIdAlias' &&
        !$scope.idFieldRequired &&
        $scope.nameAndLastNameFieldsRequired
      ) {
        $scope.place.configuration.aliasType = 'fullNameAlias';
      } else if (
        aliasType === 'fullNameAlias' &&
        !$scope.nameAndLastNameFieldsRequired &&
        $scope.idFieldRequired
      ) {
        $scope.place.configuration.aliasType = 'lastIdAlias';
      }

      if (aliasType !== $scope.place.configuration.aliasType) {
        NotificationService.Information(
          $translate
            .instant('alias_has_been_changed')
            .replace('{aliasType}', $translate.instant($scope.place.configuration.aliasType)),
        );
      }
    }
  };

  // Data for angular wizard
  const categoriesPromise = CategoryService.GetAllAsPromise();
  const aliasTypesPromise = PlaceService.GetAliasTypes();

  const getEndUserPersonalData = () => {
    const endUserDataKeys = Object.keys($scope.place.configuration.endUserPersonalData);

    endUserDataKeys.forEach((key) => {
      const value = {
        name: key,
        qmsShow: $scope.place.configuration.endUserPersonalData[key].qms.show,
        qmsRequired: $scope.place.configuration.endUserPersonalData[key].qms.required,
        webAgendaShow: $scope.place.configuration.endUserPersonalData[key].webAgenda.show,
        webAgendaRequired: $scope.place.configuration.endUserPersonalData[key].webAgenda.required,
      };
      $scope.endUserPersonalData.push(value);
    });
  };

  const getCurrentSearchField = () => {
    const currentSearchField = $scope.endUserPersonalData.find(
      (field) => field.name === $scope.place.configuration.searchAppointmentsBy,
    );
    if (!currentSearchField) {
      const enabledSearchFields = $scope.endUserPersonalData.find(field => field.webAgendaRequired);
      $scope.place.configuration.searchAppointmentsBy = enabledSearchFields.name === 'lastName' ? 'name' : enabledSearchFields.name;
      NotificationService.Warning($translate.instant('searchField_changed'));
    }
  }

  Promise.all([categoriesPromise, aliasTypesPromise]).then(([categories, aliasTypes]) => {
    $scope.data = {
      confirmPassword: '',
      phone: '',
      locationAsString: '',
      address: '',
      virtualineImage: '',
      mobileAppImage: '',
      results: [],
      addressResults: [],
      selectedCategory: [],
      categories,
      aliasTypes,
      selectedPlace: '',
      timezones: TimezoneService.List,
      addressSearch: '',
      selectedAddress: '',
    };

    if (placeId) {
      PlaceService.GetOneAsPromiseFromServer(placeId)
        .then((place) => {
          $timeout(async () => {
            $scope.place = PlaceService.Copy(place);
            $scope.data.selectedPlace = PlaceService.Copy(place);
            $scope.data.phone = $scope.place.info.phones[0] || '';
            $scope.status.showTooltip = true;
            $scope.data.locationAsString = [place.location.lat, place.location.lng];
            $scope.data.address = $scope.place.info.address;
            $scope.place.configuration.searchAppointmentsBy =
              $scope.place.configuration.searchAppointmentsBy === 'id'
                ? 'identification'
                : $scope.place.configuration.searchAppointmentsBy;
            $scope.place.metadata = $scope.place.metadata || {
              ...emptyPlace.metadata,
            };

            setMetadataMapTextFromMaps();

            PlaceMessagesService.GetAllAsPromise(placeId)
              .then((messages) => {
                $timeout(() => {
                  $scope.placeMessages = messages;
                });
              })
              .catch(ErrorService.handler);

            // Set categories
            $scope.place.categories.forEach((category) => {
              const c = $scope.data.categories.find((cate) => category == cate.key);
              if (c) {
                $scope.data.selectedCategory.push(c);
              }
            });

            await setCountryAndIdentifications($scope.place);

            LineFlowTypeOrganizationService.GetAllEnabledByPlace(placeId, true).then((lftoList) => {
              $scope.lineFlowTypeOrganizationList = lftoList;
              const found = $scope.lineFlowTypeOrganizationList.find(
                (lfto) => lfto._id == $scope.place.defaultLineFlowTypeOrganization,
              );
              $scope.lineFlowTypeOrganizationSelected =
                found || $scope.lineFlowTypeOrganizationList[0];
            });
            const userDataSettings = $scope.place.configuration.endUserPersonalData;
            $scope.idFieldRequired =
              (userDataSettings.identification.webAgenda.required &&
                userDataSettings.identification.qms.required) ||
              false;
            $scope.nameAndLastNameFieldsRequired =
              (userDataSettings.name.webAgenda.required &&
                userDataSettings.lastName.webAgenda.required &&
                userDataSettings.name.qms.required &&
                userDataSettings.lastName.qms.required) ||
              false;
            populateSurveyMonkey();
            getEndUserPersonalData();
            getCurrentSearchField();
          });
        })
        .catch(ErrorService.handler);
    } else {
      $scope.place = cloneDeep(emptyPlace);
      LineFlowTypeOrganizationService.GetAllEnabledByOrganization(organization._id, true).then(
        (lftoList) => {
          $scope.lineFlowTypeOrganizationList = lftoList;
          const found = $scope.lineFlowTypeOrganizationList.find(
            (lfto) => lfto._id == organization.defaultLineFlowTypeOrganization,
          );
          $scope.lineFlowTypeOrganizationSelected = found || $scope.lineFlowTypeOrganizationList[0];
          $scope.place.defaultLineFlowTypeOrganization =
            $scope.lineFlowTypeOrganizationSelected._id;
          emptyPlace.defaultLineFlowTypeOrganization = $scope.place.defaultLineFlowTypeOrganization;
        },
      );
      $scope.place.categories.forEach((category) => {
        const c = $scope.data.categories.find((cate) => category == cate.key);
        if (c) {
          $scope.data.selectedCategory.push(c);
        }
      });
      $scope.endUserPersonalData = get($scope.place, 'configuration.endUserPersonalData', null);
      const idData = $scope.endUserPersonalData.find((d) => d.name === 'identification');
      const nameData = $scope.endUserPersonalData.find((d) => d.name === 'name');
      const lastNameData = $scope.endUserPersonalData.find((d) => d.name === 'lastName');
      $scope.idFieldRequired = (idData.qmsRequired && idData.webAgendaRequired) || false;
      $scope.nameAndLastNameFieldsRequired =
        (nameData.qmsRequired &&
          nameData.webAgendaRequired &&
          lastNameData.qmsRequired &&
          lastNameData.webAgendaRequired) ||
        false;
    }
    $scope.loaded = true;
  });

  function someIdentificationChecked() {
    const identifications = $scope.place.requirements.identifications
      .filter((id) => isUndefined(id.empty))
      .filter((identification) => identification.show);

    return identifications.length;
  }

  function noIdentificationChecked() {
    return !someIdentificationChecked();
  }

  const validate = () => {
    const { name } = $scope.place;
    const { address } = $scope.place.info;
    const { timezone } = $scope.place;
    const { language } = $scope.place;
    const { checkInTolerance } = $scope.place.configuration;
    const { retained } = $scope.place.configuration;
    const { requirements } = $scope.place;
    const { city } = $scope.place.info;
    const { state } = $scope.place.info;
    const { zipCode } = $scope.place.info;
    const { country } = $scope.place.info;
    const { street } = $scope.place.info;
    const { streetNumber } = $scope.place.info;
    const lineFlowTypeOrganization = $scope.place.defaultLineFlowTypeOrganization;
    const { sla } = $scope.place.configuration;
    const inactivityMinutes = get($scope.place.configuration, 'inactivityAlert.minutes', 0);
    const checkDurationCompleteAction = get(
      $scope,
      'place.configuration.checkDurationCompleteAction',
      {},
    );
    const inactivityMails = get($scope.place.configuration, 'inactivityAlert.mails', '');
    const inactivityEnabled = get($scope.place.configuration, 'inactivityAlert.enabled', false);
    const listEmailsPattern = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    const { noAppointmentsAvailableMessage } = $scope.place.configuration;
    const overbookingQuantity = get($scope.place, 'configuration.overbooking.quantity', 0);
    const emailField = $scope.endUserPersonalData.find((pd) => pd.name === 'email');
    const phoneNumberField = $scope.endUserPersonalData.find((pd) => pd.name === 'phoneNumber');
    const qmsRequiredField = $scope.endUserPersonalData.filter((pd) => pd.qmsRequired);

    if (get(checkDurationCompleteAction, 'enabled', false)) {
      const showMessageBeforeSeconds = get(
        checkDurationCompleteAction,
        'showMessageBeforeSeconds',
        undefined,
      );
      if (
        isNaN(showMessageBeforeSeconds) ||
        showMessageBeforeSeconds < 1 ||
        showMessageBeforeSeconds > 300 ||
        showMessageBeforeSeconds.toString().indexOf('.') != -1 ||
        showMessageBeforeSeconds.toString().indexOf(',') != -1
      ) {
        NotificationService.Warning($translate.instant('place.show_message_before_seconds_range'));
        return false;
      }
    }

    const {
      metadata,
      metadata: { fields },
    } = $scope.place;

    if (metadata.enabled) {
      if (!fields.identifier && !fields.email && !fields.phone) {
        NotificationService.Warning($translate.instant('mandatory_metadata_identifier'));
        return false;
      }
    }

    const reasons = $scope.place.configuration.reasons.filter((r) => (r || '').trim().length > 0);

    if (inactivityEnabled && (!inactivityMails || !listEmailsPattern.test(inactivityMails))) {
      NotificationService.Warning($translate.instant('enter_mails'));
      return false;
    }
    if (inactivityEnabled && (!inactivityMinutes || inactivityMinutes <= 0)) {
      NotificationService.Warning($translate.instant('enter_minutes'));
      return false;
    }

    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_place_name'));
      return false;
    }

    if (inactivityEnabled && (inactivityMinutes < 5 || inactivityMinutes > 60)) {
      NotificationService.Warning($translate.instant('inactivity_alert_minutes_error'));
      return false;
    }

    if (name && !namePattern.test(name)) {
      NotificationService.Warning($translate.instant('invalid_place_name'));
      return false;
    }

    if (name.length > 100) {
      NotificationService.Warning($translate.instant('place_name_too_long'));
      return false;
    }

    if (!language) {
      NotificationService.Warning($translate.instant('mandatory_lang_place'));
      return false;
    }

    if (!timezone) {
      NotificationService.Warning($translate.instant('mandatory_timezone_place'));
      return false;
    }

    if (!city) {
      NotificationService.Warning($translate.instant('mandatory_city_place'));
      return false;
    }

    if (!state) {
      NotificationService.Warning($translate.instant('mandatory_state_place'));
      return false;
    }

    if (!zipCode) {
      NotificationService.Warning($translate.instant('mandatory_zip_place'));
      return false;
    }

    if (!country) {
      NotificationService.Warning($translate.instant('mandatory_country_place'));
      return false;
    }

    if (!address || !street || !streetNumber) {
      NotificationService.Warning($translate.instant('mandatory_address_place'));
      return false;
    }

    if (
      !checkInTolerance ||
      checkInTolerance > 100 ||
      checkInTolerance < 2 ||
      checkInTolerance.toString().indexOf('.') != -1 ||
      checkInTolerance.toString().indexOf(',') != -1
    ) {
      NotificationService.Warning($translate.instant('place_checkin_tolerance_range'));
      return false;
    }

    if (retained.enabled && (retained.days <= 0 || retained.days === undefined)) {
      NotificationService.Warning($translate.instant('retained_days_error'));
      return false;
    }

    if (sla < 0 || sla > 1000 || isUndefined(sla)) {
      NotificationService.Warning($translate.instant('sla_minutes_error'));
      return false;
    }

    if (noIdentificationChecked()) {
      NotificationService.Warning($translate.instant('mandatory_at_least_one_id'));
      return false;
    }

    if (!requirements.identifications.find((id) => id.default)) {
      NotificationService.Warning($translate.instant('mandatory_at_least_one_default_id'));
      return false;
    }

    if ($scope.place.configuration.requestReasonAndMotive && reasons.length === 0) {
      NotificationService.Warning($translate.instant('mandatory_reasons'));
      return false;
    }

    if (!lineFlowTypeOrganization) {
      NotificationService.Warning($translate.instant('mandatory_call_logic'));
      return false;
    }

    if (noAppointmentsAvailableMessage && noAppointmentsAvailableMessage.length > 150) {
      NotificationService.Warning($translate.instant('noAppointments_message_too_long'));
      return false;
    }

    if (!isNumber(overbookingQuantity) || overbookingQuantity > 30 || overbookingQuantity < 1) {
      NotificationService.Warning($translate.instant('overbooking_max_min'));
      return false;
    }

    if (!validateCapacityControl()) {
      return false;
    }

    if (!validateSurveyMonkey()) {
      return false;
    }

    if (placeId && !emailField.webAgendaRequired && !phoneNumberField.webAgendaRequired) {
      NotificationService.Warning(
        $translate
          .instant('email_or_phone_number_required')
          .replace('{sectionName}', $translate.instant('agendas_show_required_fields_settings')),
      );
      return false;
    }

    if (!qmsRequiredField.length) {
      NotificationService.Warning(
        $translate
          .instant('qms_at_least_one_field_required')
          .replace('{sectionName}', $translate.instant('qms_show_required_fields_settings')),
      );
      return false;
    }

    return true;
  };

  $scope.validateSpontaneousAndCheckinButton = (prop) => {
    if (prop === 'canConfirmSpontaneous') {
      if (
        !$scope.place.configuration.canConfirmSpontaneous &&
        !$scope.place.mobileAppConfig.showCheckInButton
      ) {
        $scope.place.mobileAppConfig.showCheckInButton = true;
        NotificationService.Information($translate.instant('set_showCheckInButton'), {
          timeOut: 10000,
        });
      }
    }
    if (prop === 'showCheckInButton') {
      if (
        !$scope.place.mobileAppConfig.showCheckInButton &&
        !$scope.place.configuration.canConfirmSpontaneous
      ) {
        $scope.place.configuration.canConfirmSpontaneous = true;
        NotificationService.Information($translate.instant('set_canConfirmSpontaneous'), {
          timeOut: 10000,
        });
      }
    }
  };

  const validateCapacityControl = () => {
    const supportTwoWaysSMS = get(
      $scope.place,
      'capacityControl.configuration.supportTwoWaysSMS',
      false,
    );

    const defaultMessages = get($scope.place, 'capacityControl.configuration.defaultMessages', []);

    if (supportTwoWaysSMS && defaultMessages.length) {
      for (const message of defaultMessages) {
        if (!message.name || !message.content) {
          NotificationService.Warning($translate.instant('default_message_name_content_required'));
          return false;
        }
      }
    }

    return true;
  };

  const setMetadataMapTextFromMaps = () => {
    const {
      place: { metadata },
    } = $scope;

    metadata.fields.mapText = '';

    if (metadata.enabled) {
      metadata.fields.mapText = (metadata.fields.maps || []).join(';').toUpperCase();
    }
  };

  const setMetadataMapsFromMapText = () => {
    const {
      place: { metadata },
    } = $scope;

    metadata.fields.maps = [];

    if (metadata.enabled) {
      const mapText = (metadata.fields.mapText || '').trim();
      metadata.fields.maps = mapText !== '' ? mapText.toUpperCase().split(';') : [];
      metadata.fields.mapText = null;
      Reflect.deleteProperty($scope.place.metadata.fields, 'mapText');
    }
  };

  const covertArrayDataToObject = (arr, key) =>
    arr.reduce((acc, curr) => {
      const value = {
        qms: {
          show: curr.qmsShow,
          required: curr.qmsRequired,
        },
        webAgenda: {
          show: curr.webAgendaShow,
          required: curr.webAgendaRequired,
        },
      };
      acc[curr[key]] = value;
      return acc;
    }, {});

  const save = () => {
    $scope.place.userAdmin.local.password = AuthService.Encrypt(
      $scope.place.userAdmin.local.password,
    );
    return PlaceService.Create($scope.place);
  };

  const update = () => {
    Reflect.deleteProperty($scope.place, 'userAdmin');
    saveSurveyMonkey();
    return PlaceService.UpdateWithCallLogic(
      $scope.place,
      $scope.editCallLogicsScope.selectedOption,
    );
  };

  const saveOrUpdate = () => {
    const isUpdate = !!placeId;
    const saveOrUpdatePromise = isUpdate ? update() : save();
    const mesageSucc = isUpdate ? 'changes_saved' : 'stablish_succ';
    return saveOrUpdatePromise
      .then((result) => {
        NotificationService.Success($translate.instant(mesageSucc));

        uploadMetdataFile(result._id).then(angular.noop);

        $uibModalInstance.close('cancel');
      })
      .catch((error) => {
        ErrorService.handler(error);
        $scope.blockSaveButton = false;

        setMetadataMapTextFromMaps();
      });
  };

  const preSave = () => {
    $scope.blockSaveButton = true;
    $scope.place.categories = $scope.data.selectedCategory.map((category) => category.key);
    $scope.place.info.phones[0] = $scope.data.phone;
    if (!$scope.place.branchId) {
      Reflect.deleteProperty($scope.place, 'branchId');
    }

    if (!$scope.place.checkInCode) {
      Reflect.deleteProperty($scope.place, 'checkInCode');
    }

    if (!$scope.place.configuration.requestReasonAndMotive) {
      $scope.place.configuration.reasons = [];
    } else {
      $scope.place.configuration.reasons = $scope.place.configuration.reasons.filter(
        (r) => (r || '').trim().length > 0,
      );
    }

    $scope.place.configuration.endUserPersonalData = covertArrayDataToObject(
      $scope.endUserPersonalData,
      'name',
    );

    $scope.place.configuration.searchAppointmentsBy =
      $scope.place.configuration.searchAppointmentsBy === 'identification'
        ? 'id'
        : $scope.place.configuration.searchAppointmentsBy;

    setMetadataMapsFromMapText();
  };

  $scope.save = () => {
    if (validate()) {
      preSave();

      return saveOrUpdate();
    }
  };

  $scope.cancel = () => {
    dialog
      .confirm($translate.instant('modal_cancel'))
      .then(() => $uibModalInstance.dismiss('cancel'))
      .catch(() => 'canceled');
  };

  $scope.requirementChange = (type) => {
    $timeout(() => {
      const field = $scope.searchFields.find((field) => field.name === type);
      $scope.searchFields[$scope.searchFields.indexOf(field)].enabled =
        type === 'email'
          ? $scope.place.requirements.virtualine[type]
          : $scope.place.requirements[type];
      if (
        $scope.place.configuration.searchAppointmentsBy === type &&
        !$scope.searchFields[$scope.searchFields.indexOf(field)].enabled
      ) {
        const enabledSearchFields = $scope.searchFields.filter((field) => field.enabled);
        $scope.place.configuration.searchAppointmentsBy = enabledSearchFields[0].name === 'lastName' ? 'name' : enabledSearchFields[0].name;
        NotificationService.Warning($translate.instant('searchField_changed'));
      }
    });
  };

  // Location
  const findByStablishment = () => {
    if (
      $scope.data &&
      $scope.data.address &&
      $scope.data.address.length >= 3 &&
      !$scope.data.selectedPlace
    ) {
      return LocationService.FindStablishments($scope.data.address).then((result) => {
        $timeout(() => {
          $scope.data.results = result;
        });
      });
    }
  };

  const findByAddress = () => {
    const search = $scope.data ? $scope.data.addressSearch : null;
    if (search && search.length >= 3 && !$scope.data.selectedAddress) {
      return LocationService.FindAddresses(search).then((result) => {
        $timeout(() => {
          $scope.data.addressResults = result;
        });
      });
    }
  };

  $scope.selectPlace = (place) => {
    if (place.place_id) {
      // Set description on search input
      if (place.description) {
        $scope.data.address = place.description;
      }

      // Get the details of the place selected by user
      LocationService.GetPlaceDetails(place.place_id).then((placeDetails) => {
        $timeout(async () => {
          $scope.data.selectedPlace = placeDetails;
          $scope.data.locationAsString = [
            placeDetails.geometry.location.lat(),
            placeDetails.geometry.location.lng(),
          ];
          $scope.place.location = {
            lat: placeDetails.geometry.location.lat(),
            lng: placeDetails.geometry.location.lng(),
          };
          await autocompleteFields(placeDetails);
        });
      });
    }

    $scope.data.results = [];
  };

  $scope.requestReasonAndMotiveChange = (value) => {
    if (!value) {
      $scope.place.configuration.reasonRequired = false;
    }
  };

  $scope.userBoxChange = (value) => {
    if (value) {
      $scope.place.configuration.boxLabelRequired = false;
    }
  };

  $scope.adminBoxChange = (value) => {
    if (value) {
      $scope.place.configuration.user.useBoxLabelByPace.enabled = false;
      $scope.place.configuration.user.useBoxLabelByPace.required = false;
      $scope.place.configuration.user.useBoxLabelByPace.isNumeric = false;
    }
  };

  $scope.selectAddress = (address) => {
    const googlePlaceId = address.place_id;
    if (googlePlaceId) {
      // Set description on search input
      if (address.description) {
        $scope.data.addressSearch = address.description;
      }

      // Get the details of the place selected by user
      LocationService.GetPlaceDetails(googlePlaceId).then((placeDetails) => {
        $timeout(async () => {
          $scope.data.selectedAddress = placeDetails;
          $scope.place.location = {
            lat: placeDetails.geometry.location.lat(),
            lng: placeDetails.geometry.location.lng(),
          };
          await autocompleteFields(placeDetails, true);
        });
      });
    }
    $scope.data.addressResults = [];

    $timeout(async () => await setCountryAndIdentifications($scope.place));
  };

  $scope.$watch('data.address', debounce(findByStablishment, 500));
  $scope.$watch('data.addressSearch', debounce(findByAddress, 500));

  // Place info
  /* eslint-disable camelcase */
  async function autocompleteFields(placeDetails, excludeName) {
    const { name, website, formatted_phone_number, formatted_address, place_id } = placeDetails;

    if (name && !excludeName) {
      $scope.place.name = name;
    }

    $scope.place.info.website = website || organization.website;
    $scope.data.phone = formatted_phone_number || organization.phoneNumber;

    if (formatted_address) {
      $scope.place.info.address = formatted_address;
    }

    if (placeDetails.opening_hours) {
      $scope.place.openingDetails.periods = placeDetails.opening_hours.periods;
      $scope.place.openingDetails.weekday_text = placeDetails.opening_hours.weekday_text;
    }

    // Google place id
    $scope.place.googlePlaceId = place_id;
    /* eslint-enable camelcase */

    // Check in code
    $scope.place.checkInCode = `${Slug.slugify(placeDetails.name)}_check_in`;

    // Address components
    Object.assign($scope.place.info, LocationService.GetLocationInfo(placeDetails));

    // Timezone
    $scope.place.timezone = tzlookup(
      placeDetails.geometry.location.lat(),
      placeDetails.geometry.location.lng(),
    );

    await setCountryAndIdentifications($scope.place);
  }

  $scope.restartSelectedPlace = () => {
    $scope.data.results = [];
    $scope.data.selectedPlace = '';
    $scope.data.address = '';
    $scope.data.locationAsString = '';
    $scope.data.addressSearch = '';
    $scope.data.addressResults = [];
    $scope.data.selectedAddress = '';

    if (!placeId) {
      const { userAdmin } = $scope.place;
      $scope.place = cloneDeep(emptyPlace);
      $scope.place.userAdmin = userAdmin;
      $scope.status = {
        ...$scope.status,
        location: {
          isOpen: true,
          isDisabled: false,
        },
        information: {
          isOpen: false,
          isDisabled: true,
          shouldNameBeFocused: false,
        },
        configuration: {
          isOpen: false,
          isDisabled: true,
        },
      };
    }
  };

  $scope.checkIfUserExists = (email) => {
    UserService.CheckIfExists(email).then((res) => {
      $timeout(() => {
        const user = res[0];
        if (user) {
          $scope.userExists = true;
          $scope.place.userAdmin = {
            _id: user._id,
            local: {
              email: user.local.email,
            },
            profile: {
              firstName: user.profile.firstName,
              lastName: user.profile.lastName,
            },
          };
          NotificationService.Information($translate.instant('user_autocompleted'));
        } else {
          $scope.userExists = false;
          Reflect.deleteProperty($scope.place.userAdmin, '_id');
          NotificationService.Information($translate.instant('user_not_exist'));
        }
        $scope.canComplete = true;
      });
    });
  };

  $scope.addReason = () => {
    $scope.place.configuration.reasons.unshift('');
  };

  $scope.deleteReason = (reason) => {
    dialog
      .confirm($translate.instant('reason_remove_sure'))
      .then(() => {
        pull($scope.place.configuration.reasons, reason);
        NotificationService.Information($translate.instant('reason_remove_succ'));
      })
      .catch(ErrorService.handler);
  };

  $scope.emailChanged = () => {
    if ($scope.canComplete) {
      $scope.place.userAdmin = {
        local: {
          email: '',
          password: '',
        },
        profile: {
          firstName: '',
          lastName: '',
        },
      };
      $scope.userExists = true;
      $scope.canComplete = false;
    }
  };

  $scope.checkStep = {
    user: () => {
      if ($scope.forms.userPlace.$valid && !placeId) {
        $scope.status = {
          ...$scope.status,
          user: {
            isOpen: false,
          },
          location: {
            isOpen: true,
            isDisabled: false,
          },
        };
      }
    },
    location: () => {
      if ($scope.data.selectedPlace || $scope.status.noPlace) {
        $scope.status = {
          ...$scope.status,
          location: {
            isOpen: false,
            isDisabled: false,
          },
          information: {
            isOpen: true,
            isDisabled: false,
            shouldNameBeFocused: true,
          },
          configuration: {
            isDisabled: true,
          },
        };
      }
      if (placeId) {
        $scope.status.showTooltip = false;
      }
    },
    information: () => {
      if ($scope.forms.informationPlace.$valid) {
        $scope.status = {
          ...$scope.status,
          information: {
            isOpen: false,
            isDisabled: false,
            shouldNameBeFocused: false,
          },
          configuration: {
            isOpen: true,
            isDisabled: false,
          },
        };
      }
      if (placeId) {
        $scope.status.showTooltip = true;
        $scope.status.information.isDisabled = true;
      }
    },
  };

  async function setCountryAndIdentifications(place) {
    const location = (await LocationService.Find(place.info.address))[0];

    const countryFound = await CountryService.FindByCode(location.code);

    const country =
      countryFound ||
      (await CountryService.Create({
        code: location.code,
        name: location.country,
      }));

    $scope.place.location.country = country._id;
    $scope.place.location.countryCode = country.code;
    $scope.country = country.name;
    $scope.place.requirements.identifications = mergeCountryIdentifications(
      country.identifications,
      get(place, 'requirements.identifications', []),
    );

    $scope.placeIdentifications = [...$scope.place.requirements.identifications];

    addEmptyIdentification($scope.place.requirements.identifications);

    $scope.setDefaultIndentificationsList();
  }

  function mergeCountryIdentifications(countryIdentifications, placeIdentifications) {
    return countryIdentifications.map((identification) => {
      identification.show = identification.selected;
      Reflect.deleteProperty(identification, 'selected');
      return placeIdentificationOrDefault(placeIdentifications, identification);
    });
  }

  function placeIdentificationOrDefault(placeIdentifications, identification) {
    const placeIdentification = placeIdentifications.find((p) => p.key === identification.key);
    return { ...identification, ...placeIdentification };
  }

  $scope.autoCheckInChange = (value) => {
    $scope.place.mobileAppConfig.showCheckInButton = !value;
    if (value) {
      $scope.place.mobileAppConfig.showQRCode = false;
      $scope.place.configuration.canConfirmSpontaneous = false;
    }
  };

  $scope.refreshCallLogic = () => {
    PlaceService.RefreshCallLogic(placeId)
      .then(() => {
        NotificationService.Success($translate.instant('call_logic_reseted'));
      })
      .catch(ErrorService.handler);
  };

  $scope.isDynamicAlias = () => {
    const dynamicAlias = 'dynamicAlias';
    const aliasType = get($scope, 'place.configuration.aliasType');
    let aliasGetter = get($scope, 'place.configuration.aliasGetter');
    const isDinamycAlias = aliasType === dynamicAlias;

    if (isDinamycAlias && !aliasGetter) {
      const fun = `
/* context = {_, subscription} 
  * _ = lodash
  * virtualine subscription 
  */
(function() { return _.get(subscription, '_id', 'default-value')}());
      `;

      const isDynamicAliasOnOrganization =
        get(organization, 'configuration.queuer.aliasType', null) === dynamicAlias;

      aliasGetter = isDynamicAliasOnOrganization
        ? get(organization, 'configuration.queuer.aliasGetter', fun)
        : fun;

      $timeout(() => {
        set($scope, 'place.configuration.aliasGetter', aliasGetter);
      });
    }

    return isDinamycAlias;
  };

  $scope.onChangeCapacityControlEnabled = () => {
    set($scope, 'place.capacityControl.configuration.requiresConfirmation', false);
  };

  $scope.addSMS = () => {
    const messageEmpty = {
      name: '',
      content: '',
    };

    if (!$scope.place.capacityControl.configuration.defaultMessages) {
      $scope.place.capacityControl.configuration.defaultMessages = [];
    }

    $scope.place.capacityControl.configuration.defaultMessages.push(messageEmpty);
  };

  $scope.removeSms = (message) => {
    const index = $scope.place.capacityControl.configuration.defaultMessages.indexOf(message);
    $scope.place.capacityControl.configuration.defaultMessages.splice(index, 1);
  };

  $scope.onChangeRequiresConfirmation = () => {
    set($scope, 'place.capacityControl.configuration.supportDelay', false);
    set($scope, 'place.capacityControl.configuration.enterWithoutConfirmation', false);
  };

  const populateSurveyMonkey = () => {
    const savedCompletedDelayDeliveryUnit = get(
      $scope.place,
      'surveyMonkey.completed.delayDelivery.unit',
      null,
    );

    const completedSelectedOption = $scope.delayDeliveryUnitOfTime.options.find(
      (o) => o.key === savedCompletedDelayDeliveryUnit,
    );

    $scope.delayDeliveryUnitOfTime.completedSelectedOption = completedSelectedOption
      ? completedSelectedOption.key
      : $scope.delayDeliveryUnitOfTime.options[0].key;

    const savedCanceledDelayDeliveryUnit = get(
      $scope.place,
      'surveyMonkey.canceled.delayDelivery.unit',
      null,
    );

    const canceledSelectedOption = $scope.delayDeliveryUnitOfTime.options.find(
      (o) => o.key === savedCanceledDelayDeliveryUnit,
    );

    $scope.delayDeliveryUnitOfTime.canceledSelectedOption = canceledSelectedOption
      ? canceledSelectedOption.key
      : $scope.delayDeliveryUnitOfTime.options[0].key;

    $scope.surveyMonkey = {
      completed: {
        enabled: get($scope.place, 'surveyMonkey.completed.enabled', false),
        link: get($scope.place, 'surveyMonkey.completed.link', ''),
        delayDelivery: {
          value: get($scope.place, 'surveyMonkey.completed.delayDelivery.value', 0),
          unit: $scope.delayDeliveryUnitOfTime.completedSelectedOption,
        },
      },
      canceled: {
        enabled: get($scope.place, 'surveyMonkey.canceled.enabled', false),
        link: get($scope.place, 'surveyMonkey.canceled.link', ''),
        delayDelivery: {
          value: get($scope.place, 'surveyMonkey.canceled.delayDelivery.value', 0),
          unit: $scope.delayDeliveryUnitOfTime.canceledSelectedOption,
        },
      },
    };
  };

  const saveSurveyMonkeySettings = () => {
    let surveyMonkeyCompleted = {
      enabled: false,
    };

    let surveyMonkeyCanceled = {
      enabled: false,
    };

    if (get($scope.surveyMonkey, 'completed.enabled', false)) {
      surveyMonkeyCompleted = {
        enabled: true,
        link: get($scope.surveyMonkey, 'completed.link'),
        delayDelivery: {
          value: get($scope.surveyMonkey, 'completed.delayDelivery.value'),
          unit: $scope.delayDeliveryUnitOfTime.completedSelectedOption,
        },
      };
    }

    if (get($scope.surveyMonkey, 'canceled.enabled', false)) {
      surveyMonkeyCanceled = {
        enabled: true,
        link: get($scope.surveyMonkey, 'canceled.link'),
        delayDelivery: {
          value: get($scope.surveyMonkey, 'canceled.delayDelivery.value'),
          unit: $scope.delayDeliveryUnitOfTime.canceledSelectedOption,
        },
      };
    }

    const surveyMonkey = {
      completed: surveyMonkeyCompleted,
      canceled: surveyMonkeyCanceled,
    };

    return surveyMonkey;
  };

  const validateSurveyMonkey = () => {
    const completedEnabled = get($scope.surveyMonkey, 'completed.enabled', false);
    const completedLink = get($scope.surveyMonkey, 'completed.link', '');
    const completedDelayDeliveryValue = get(
      $scope.surveyMonkey,
      'completed.delayDelivery.value',
      '',
    );
    const completedDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.completedSelectedOption;

    const canceledEnabled = get($scope.surveyMonkey, 'canceled.enabled', false);
    const canceledLink = get($scope.surveyMonkey, 'canceled.link', '');
    const canceledDelayDeliveryValue = get($scope.surveyMonkey, 'canceled.delayDelivery.value', '');
    const canceledDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.canceledSelectedOption;

    const minDelayDeliveryValue = 10;
    const minDelayDeliveryUnit = $scope.delayDeliveryUnitOfTime.options[0];

    if ((completedEnabled && !completedLink) || (canceledEnabled && !canceledLink)) {
      const message = $translate.instant(
        $translate.instant('mandatory_{name}').replace('{name}', 'link'),
      );
      NotificationService.Warning(message);
      return false;
    }

    if (
      (completedEnabled && !completedDelayDeliveryValue) ||
      (canceledEnabled && !canceledDelayDeliveryValue)
    ) {
      const message = $translate.instant(
        $translate
          .instant('mandatory_{name}')
          .replace('{name}', $translate.instant('survey_delay_delivery')),
      );
      NotificationService.Warning(message);
      return false;
    }

    if (
      (completedEnabled &&
        completedDelayDeliveryValue &&
        completedDelayDeliveryValue < minDelayDeliveryValue &&
        completedDelayDeliveryUnit === minDelayDeliveryUnit.key) ||
      (canceledEnabled &&
        canceledDelayDeliveryValue &&
        canceledDelayDeliveryValue < minDelayDeliveryValue &&
        canceledDelayDeliveryUnit === minDelayDeliveryUnit.key)
    ) {
      const message = $translate
        .instant('survey_delay_delivery_message_minimum_validation')
        .replace('{minValue}', minDelayDeliveryValue)
        .replace('{minUnit}', $translate.instant('seconds'));
      NotificationService.Warning(message);
      return false;
    }

    return true;
  };

  const saveSurveyMonkey = () => {
    $scope.place.surveyMonkey = saveSurveyMonkeySettings();
  };
};

module.exports = module.controller('PlaceModalController', PlaceModalController);
